(() => {
  const node=document.getElementById('fleecia-pricing-context');
  if(!node)return;
  const context=JSON.parse(node.textContent);
  if(context.currency!=='GBP')return;
  const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
  function formatText(node){
    if(node.nodeType!==3||!node.parentElement||node.parentElement.closest('script,style,noscript,textarea'))return;
    const old=node.nodeValue;
    if(!old.includes('$'))return;
    const value=old.replace(/\$(\d[\d,]*(?:\.\d{1,2})?)/g,(_,amount)=>money.format(Number(amount.replace(/,/g,''))));
    if(value!==old)node.nodeValue=value;
  }
  function formatTree(node){
    if(node.nodeType===3){formatText(node);return;}
    const walker=document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
    while(walker.nextNode())formatText(walker.currentNode);
  }
  function initialize(){
    formatTree(document.body);
    new MutationObserver(records=>{
      for(const record of records){
        if(record.type==='characterData')formatText(record.target);
        else for(const child of record.addedNodes)formatTree(child);
      }
    }).observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
